import { Inject, Injectable } from '@angular/core'
import { Router, UrlTree } from '@angular/router'
import { API_CONFIGURATION, FullApiClientConfiguration } from '@ftr/api-shared'
import { AppPaths, LogoutParams } from '@ftr/routing-paths'
import { AuthenticationService, SignOutReason } from '@ftr/ui-user'
import { Store } from '@ngxs/store'

const PRODUCTION_WEB_APP_URL = 'https://app.fortherecord.com'

@Injectable({
  providedIn: 'root',
})
export class GlobalAdminEnforcementGuard {
  constructor(
    private readonly router: Router,
    private readonly store: Store,
    private readonly authenticationService: AuthenticationService,
    @Inject(API_CONFIGURATION) private readonly configurationService: FullApiClientConfiguration,
  ) {}

  async canActivate(): Promise<boolean | UrlTree> {
    await this.authenticationService.initialize()
    const satisfyMFARequirements = await this.satisfyMFARequirements()
    const isGlobalAdmin = this.authenticationService.currentUser?.isGlobalAdministrator
    const signOutReason = isGlobalAdmin ? SignOutReason.MFA_REQUIRED : SignOutReason.UNAUTHORIZED
    return isGlobalAdmin && satisfyMFARequirements
      ? true
      : this.router.createUrlTree([AppPaths.Logout], {
          queryParams: { [LogoutParams.LogoutReason]: signOutReason },
        })
  }

  canActivateChild(): Promise<boolean | UrlTree> {
    return this.canActivate()
  }

  private async satisfyMFARequirements(): Promise<boolean> {
    const mfaRequired = this.configurationService.webAppUrl === PRODUCTION_WEB_APP_URL
    if (!mfaRequired) {
      return true
    }
    return !!(
      this.authenticationService.currentUser && (await this.authenticationService.multifactorAuthenticationEnabled)
    )
  }
}
